/**
 * Onboarding page — i18n content swap
 * Works with the Language Toggle's window.OffbitsLang + 'offbits:langchange'
 * event. Swaps text on any element carrying data-i18n (plain text) or
 * data-i18n-html (rich text / HTML) to the matching key in
 * onboarding-i18n.json. Falls back silently to the original English if a
 * key is missing, so nothing ever breaks or goes blank.
 */
(function () {
  let translations = null;

  function fetchTranslations() {
    if (!window.OffbitsI18nDataUrl) return Promise.resolve(null);
    return fetch(window.OffbitsI18nDataUrl)
      .then((res) => res.json())
      .catch(() => null);
  }

  function cacheOriginal(el, attr, prop) {
    const cacheAttr = 'i18nOriginal' + (attr === 'data-i18n-html' ? 'Html' : '');
    if (el.dataset[cacheAttr] === undefined) {
      el.dataset[cacheAttr] = el[prop];
    }
    return el.dataset[cacheAttr];
  }

  function applyTranslations(lang) {
    // Plain text elements
    document.querySelectorAll('[data-i18n]').forEach((el) => {
      const original = cacheOriginal(el, 'data-i18n', 'textContent');
      if (lang === 'en' || !translations) {
        el.textContent = original;
        return;
      }
      const key = el.getAttribute('data-i18n');
      const dict = translations[lang] || {};
      el.textContent = dict[key] || original;
    });

    // Rich text / HTML elements
    document.querySelectorAll('[data-i18n-html]').forEach((el) => {
      const original = cacheOriginal(el, 'data-i18n-html', 'innerHTML');
      if (lang === 'en' || !translations) {
        el.innerHTML = original;
        return;
      }
      const key = el.getAttribute('data-i18n-html');
      const dict = translations[lang] || {};
      el.innerHTML = dict[key] || original;
    });
  }

  function init() {
    fetchTranslations().then((json) => {
      translations = json;
      const current = window.OffbitsLang ? window.OffbitsLang.get() : 'en';
      applyTranslations(current);
    });

    document.addEventListener('offbits:langchange', (e) => {
      applyTranslations(e.detail.lang);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();